import { Box, IconButton, Stack } from '@mui/material';
import { PlusCircleIcon, TrashIcon } from '@phosphor-icons/react';
import { useId } from 'react';

import { isDefined } from 'common';

import { useReactFlowViewContext } from '../../../../../../context/context';
import { BlockValueTemplateInnerField } from '../../../../../ConfigFields/CodeMirror/FlowTemplate';
import { type HumanTaskBlockFormFieldsProps } from '../types';

interface HumanTaskBlockOptionProps extends HumanTaskBlockFormFieldsProps {
  label: string;
  onAdd?: () => void;
  onDelete?: () => void;
}

export function HumanTaskBlockOption(props: HumanTaskBlockOptionProps) {
  const { fieldNamePrefix, onAdd, onDelete, label } = props;
  const { isEditable } = useReactFlowViewContext();
  const id = useId();

  return (
    <Stack direction="row" gap={1} alignItems="center">
      <Box flex={1}>
        <BlockValueTemplateInnerField
          fieldId={id}
          label={label}
          fieldName={`${fieldNamePrefix}.label`}
        />
      </Box>
      {isEditable && (
        <Stack direction="row" gap={0.5}>
          <IconButton
            aria-label="Add Field"
            onClick={onAdd}
            color="primary"
            disabled={!isEditable || !isDefined(onAdd)}
          >
            <PlusCircleIcon size={24} />
          </IconButton>
          <IconButton
            aria-label="Delete Field"
            onClick={onDelete && (() => onDelete())}
            color="error"
            disabled={!isEditable || !isDefined(onDelete)}
          >
            <TrashIcon size={24} />
          </IconButton>
        </Stack>
      )}
    </Stack>
  );
}
